import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent';
import PageLoader from '../../../../../component/common/PageLoader';
const PlPricing = () => {

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const [pricingModuleData, setPricingModuleData] = useState([]);
    const [pageLoader, setPageLoader] = useState(false)

    const getPricingList = async () => {
        setPageLoader(true)
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}api/get-cms-pricing-list`, {}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                setPricingModuleData(res.data.data.data)
            } else if(res.data.status === 'error') {
                console.error('error')
            }
            setPageLoader(false)
        })
        .catch((error) => {
            console.error(error);
            setPageLoader(false)
        })
    }

    useEffect(() => {
        getPricingList()
    },[])

    let pricingListHtml = '';
    if(pricingModuleData.length > 0){
        pricingListHtml = pricingModuleData.map((resData, index) => {
            return (
                <div key={index}>
                    <div className='row' >
                        <div className='col-md-6'>
                            <p className="title">{resData.module_name}</p>
                            <p className="description">
                                {resData.includes}
                            </p>
                        </div>
                        <div className='col-md-6 text-end'>
                            <h3 className="price mt-0 fs-2x">
                                ${resData.price} 
                                <span>/ {resData.price_type}</span>
                            </h3>
                        </div>
                    </div>
                    {
                        pricingModuleData.length !== index +1 &&
                        <div className="separator my-8"></div>
                    }
                </div>
            );
        });
    }
    return (
        <>
            <style>
                {
                    `
                        .table-bordered {
                            border: 1px solid #dee2e6 !important;
                        }

                        .table-bordered > :not(caption) > * > * {
                            border: 1px solid #dee2e6 !important;
                        }
                    `
                }
            </style>
            {
                pageLoader &&
                <PageLoader />
            }
            {
                pricingModuleData.length > 0 &&
                <div className='row mt-10  pb-5'>
                    <div className="col-md-12 text-center mb-6">
                        <SectionHeader_2
                            title= {`Pricing`}
                        />
                    </div>
                    <div className="cta-area-wrapper pt-0 bg-none" style={{paddingLeft:'7rem', paddingRight:'7rem'}}>
                        <div className="section-heading w-100">
                            <div className="toggle-content">
                                <div className="toggle-pane show">
                                    <div className="pricing-wrapper-box">
                                        <div className="pricing-wrapper">
                                            <div className="pricing-box basic has_fade_anim">
                                                {pricingListHtml}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export {PlPricing}